import styled from 'styled-components';

export const FilterSetterWrapper = styled.div`
	margin-top: 250px;
`;
